<script>
  // One route, step by step, for walking it: each screen gets its kind and address (and an Open link); every
  // screen or IRL step gets a "tested" tick. Saves straight to the row and re-reads what came back.
  import { supabase } from '../../lib/supabase.js';
  import { showToast } from '../../lib/stores/toast.js';
  import { openable } from '../../lib/routes.js';

  let { items, tech, onChanged } = $props();

  const KINDS = [['page', 'Page'], ['door', 'Door'], ['sells', 'Sells it'], ['got', 'Got there']];

  async function save(row, patch) {
    const table = tech ? 'bb_tech_pages' : 'bb_steps';
    const { data, error } = await supabase.from(table).update(patch).eq('id', row.id).select('id');
    // A 2xx with no row back means RLS refused it — never report that as saved.
    if (error || !data?.length) { showToast(error?.message || 'Not saved', 'error'); return; }
    onChanged?.(row.id, patch);
  }

  function tested(row) { save(row, { tested_at: row.tested_at ? null : new Date().toISOString() }); }
  function url(row, v) { v = v.trim() || null; if (v !== (row.url || null)) save(row, { url: v }); }
</script>

<ol class="rs">
  {#each items as row, i (row.id + ':' + i)}
    <li class="rs-row">
      <span class="rs-n">{i + 1}</span>
      <div class="rs-main">
        <div class="rs-top">
          <span class="rs-name">{tech ? row.title : (row.step_name || 'Untitled step')}</span>
          {#if tech}
            <select value={row.kind || 'page'} onchange={(e) => save(row, { kind: e.currentTarget.value })}>
              {#each KINDS as [k, l] (k)}<option value={k}>{l}</option>{/each}
            </select>
          {/if}
          <button type="button" class="rs-tick" class:on={!!row.tested_at} onclick={() => tested(row)}
            title={row.tested_at ? 'Tested ' + new Date(row.tested_at).toLocaleDateString() : 'Mark tested'}>
            {row.tested_at ? 'Tested ✓' : 'Test'}
          </button>
        </div>
        {#if tech}
          <div class="rs-url">
            <input type="text" placeholder="Address, e.g. getmemo.me/pairs" value={row.url || ''} onblur={(e) => url(row, e.currentTarget.value)} />
            {#if row.url}<a href={openable(row.url)} target="_blank" rel="noopener">Open ↗</a>{/if}
          </div>
        {:else if row.what_user_does}
          <div class="rs-sub">{row.what_user_does}</div>
        {/if}
      </div>
    </li>
  {/each}
</ol>

<style>
  .rs { list-style: none; margin: 8px 0 0; padding: 0; display: flex; flex-direction: column; gap: 6px; }
  .rs-row { display: flex; gap: 10px; padding: 8px 10px; border-radius: 10px; background: rgba(255,255,255,0.03); border: 1px solid var(--border); }
  .rs-n { color: var(--text-dim); font-size: 12px; min-width: 16px; padding-top: 3px; }
  .rs-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 6px; }
  .rs-top { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
  .rs-name { flex: 1; min-width: 140px; font-size: 13px; color: var(--text); }
  .rs-sub { font-size: 12px; color: var(--text-muted); }
  .rs select, .rs input { background: rgba(0,0,0,0.35); border: 1px solid rgba(255,255,255,0.12); border-radius: 8px; color: var(--text); font: inherit; font-size: 12px; padding: 5px 8px; }
  .rs-url { display: flex; gap: 8px; align-items: center; }
  .rs-url input { flex: 1; min-width: 0; }
  .rs-url a { color: #7ab8ff; font-size: 12px; white-space: nowrap; text-decoration: none; }
  .rs-tick { background: transparent; border: 1px solid rgba(255,255,255,0.18); color: var(--text-muted); border-radius: 999px; padding: 4px 10px; font: inherit; font-size: 12px; cursor: pointer; }
  .rs-tick.on { background: rgba(122,184,122,0.18); border-color: rgba(122,184,122,0.6); color: #9fd49f; }
</style>
